import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useNotifications } from '@partiu/api/user/hooks';
import { FaFrown } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeProvider';
import { SectionTitle } from '../atoms/Title';

export function NotificationsDrawer({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const { isIOS } = useTheme();
  const { data: notifications } = useNotifications();

  return (
    <Drawer isOpen={isOpen} onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent paddingTop={isIOS ? '45px' : '0px'}>
        <DrawerHeader>Minhas Notificações</DrawerHeader>
        <DrawerBody>
          <VStack>
            {notifications?.results && notifications.results.length > 0 ? (
              notifications.results.map((n) => (
                <VStack>
                  {typeof n?.discount?.image === 'string' && <Image src={n.discount.image} />}
                  <SectionTitle>{n.title}</SectionTitle>
                  <Text>{n.text}</Text>
                </VStack>
              ))
            ) : (
              <VStack spacing={5} paddingTop={'50px'}>
                <FaFrown size="30px" />
                <Heading fontSize={'16px'}>Nenhuma notificação encontrada!</Heading>
              </VStack>
            )}
          </VStack>
          <DrawerCloseButton marginTop={isIOS ? '50px' : '0px'} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
